import { render } from "./ProvidesNetworkAtVeryCheapPrice.vue?vue&type=template&id=19ce0642&ts=true"
import script from "./ProvidesNetworkAtVeryCheapPrice.vue?vue&type=script&lang=ts"
export * from "./ProvidesNetworkAtVeryCheapPrice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__